import { render, staticRenderFns } from "./EditBuilding.vue?vue&type=template&id=170b6436"
import script from "./EditBuilding.vue?vue&type=script&lang=js"
export * from "./EditBuilding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports